/* GOCCE DERİ — Sticky purchase strip. The existing Shopify product form remains the source of truth. */
(()=>{
'use strict';

/* GOCCE DERİ | All products: prefer own color detail views; reuse another color's details only when missing.
   Main hero always remains the selected variant. Avoid variant covers and all-color collages in the detail rail. */
function initGocceColorGalleries() {
  document.querySelectorAll('[data-gocce-color-gallery]:not([data-color-gallery-ready])').forEach(gallery => {
    gallery.dataset.colorGalleryReady = 'true';
    const section = gallery.closest('.gocce-product-detail');
    const select = section?.querySelector('[data-product-variant-select]');
    const main = gallery.querySelector('[data-main-image]');
    const rail = gallery.querySelector('[data-gocce-support-list]');
    const tiles = [...gallery.querySelectorAll('[data-gocce-support-image]')];
    let variants = [];
    try {
      variants = JSON.parse(document.getElementById('gocce-variants-json')?.textContent || '[]');
    } catch (e) {}
    if (!main || !select || !rail || !variants.length) return;

    const normalize = str => String(str || '').normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const filename = src => {
      if (!src) return '';
      try {
        return decodeURIComponent(new URL(String(src), location.href).pathname.split('/').pop() || '')
          .replace(/\.[^.]+$/, '').replace(/_[0-9a-f]{12,}$/i, '');
      } catch (e) {
        return String(src).split('?')[0].split('/').pop().replace(/\.[^.]+$/, '');
      }
    };
    const fileKey = src => normalize(filename(src));
    const rootKey = src => fileKey(src).replace(/CANTA/g, 'CANT')
      .replace(/(?:YANFOTO|SIDE|DETAIL|DETAY|KAPAK|COVER|FRONT|ARKA|BACK|YAN|ICI|ACIK|KAPALI|OPEN|CLOSE|FOTO|PHOTO|ON|IC)\d*$/, '');
    const imageFor = variant => variant?.featured_image?.src || variant?.featured_image?.url || '';
    const covers = variants.map(v => ({
      id: String(v.id),
      src: imageFor(v),
      key: fileKey(imageFor(v)),
      root: rootKey(imageFor(v)),
      color: normalize((v.options || [])[0] || v.title || '')
    }));
    const coverKeys = new Set(covers.map(x => x.key).filter(Boolean));
    const numericPrefix = str => str.match(/^\d{3,}/)?.[0] || '';
    const isCollage = key => /(?:HEPSI|ALLCOLORS|ALLCOLOURS|COLLAGE|KOLAJ|RENKLER|TOPLU|GROUP|BUTUN)/.test(key);
    const shotType = key => {
      const m = key.match(/(?:YANFOTO|YAN|SIDE)(\d*)$/);
      if (m) return 'YAN' + (m[1] || '1');
      const back = key.match(/(?:ARKA|BACK)(\d*)$/);
      if (back) return 'ARKA' + (back[1] || '1');
      const inside = key.match(/(?:IC|ICI|ACIK|OPEN)(\d*)$/);
      if (inside) return 'IC' + (inside[1] || '1');
      const detail = key.match(/(?:DETAY|DETAIL|FERMUAR)(\d*)$/);
      if (detail) return 'DETAY' + (detail[1] || '1');
      return 'GENERIC:' + key;
    };

    const photos = tiles.map((tile, order) => {
      const src = tile.dataset.photoSource || tile.querySelector('img')?.src || '';
      const key = fileKey(src);
      if (!key || coverKeys.has(key) || isCollage(key)) return null;
      const root = rootKey(src);
      const alt = normalize(tile.dataset.photoAlt || '');
      const scores = covers.map(cover => {
        let score = 0;
        if (cover.root && root) {
          if (cover.root === root) score = 100;
          else if (root.length >= 3 && cover.root.startsWith(root)) score = 85;
          else if (cover.root.length >= 5 && root.startsWith(cover.root)) score = 75;
          const photoNum = numericPrefix(root);
          const coverNum = numericPrefix(cover.root);
          if (photoNum && photoNum === coverNum) score = Math.max(score, 90);
        }
        if (cover.color.length >= 4 && alt.includes(cover.color)) score = Math.max(score, 60);
        return { id: cover.id, score };
      }).sort((a, b) => b.score - a.score);
      // A tie is unassigned, rather than attributing a view to the wrong color.
      const owner = scores[0]?.score >= 60 && scores[0].score > (scores[1]?.score || 0)
        ? scores[0].id : null;
      return { tile, order, owner, type: shotType(key) };
    }).filter(Boolean);

    const grouped = new Map(covers.map(x => [x.id, []]));
    const general = [];
    photos.forEach(photo => {
      if (photo.owner && grouped.has(photo.owner)) grouped.get(photo.owner).push(photo);
      else general.push(photo);
    });

    let queued = false;
    const update = () => {
      queued = false;
      const current = covers.find(x => x.id === String(select.value)) || covers[0];
      const own = grouped.get(current.id) || [];
      // A single donor color supplies missing angles; do not mix unrelated donor colors.
      const donors = covers.filter(x => x.id !== current.id)
        .map(x => ({ id: x.id, photos: grouped.get(x.id) || [] }))
        .sort((a, b) => b.photos.length - a.photos.length);
      const donor = donors[0]?.photos || [];
      const visible = [];
      const types = new Set();
      const add = photo => {
        if (!types.has(photo.type)) {
          types.add(photo.type);
          visible.push(photo);
        }
      };
      own.forEach(add);         // Own color always takes precedence for each angle.
      donor.forEach(add);       // Missing angles use a different color of the same product.
      general.forEach(add);     // Non-variant-specific product detail imagery.
      const visibleTiles = new Set(visible.map(photo => photo.tile));
      tiles.forEach(tile => {
        tile.hidden = !visibleTiles.has(tile);
        tile.dataset.fallbackColor = (visible.find(p => p.tile === tile)?.owner &&
          visible.find(p => p.tile === tile)?.owner !== current.id) ? 'true' : 'false';
      });
      rail.hidden = visible.length === 0;
      gallery.dataset.hasSupport = visible.length ? 'true' : 'false';
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    section?.addEventListener('click', e => {
      if (e.target.closest('[data-option-value]')) schedule();
    });
    select.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(main, { attributes: true, attributeFilter: ['src'] });
    update();
  });
}

const init=()=>{
initGocceColorGalleries();
document.querySelectorAll('[data-gocce-video-sticky]:not([data-video-ready])').forEach(strip=>{
  strip.dataset.videoReady='1';
  const section=strip.closest('.gocce-product-detail');
  const form=section?.querySelector('[data-gocce-ajax-cart]');
  const mainAdd=form?.querySelector('[data-add-to-cart]');
  const stickyAdd=strip.querySelector('[data-gocce-video-sticky-add]');
  const currentPrice=section?.querySelector('[data-current-price]');
  const price=strip.querySelector('[data-video-sticky-price]');
  const related=section?.querySelector('.gocce-related-products');
  if(!form||!mainAdd||!stickyAdd)return;
  const update=()=>{
    if(currentPrice&&price)price.textContent=currentPrice.textContent;
    stickyAdd.disabled=mainAdd.disabled;
    const rect=form.getBoundingClientRect();
    const relatedRect=related?.getBoundingClientRect();
    const passed=rect.bottom<70;
    const within=!relatedRect||relatedRect.top>window.innerHeight*.56;
    const show=passed&&within&&window.scrollY>250;
    strip.hidden=!show;
    strip.setAttribute('aria-hidden',String(!show));
  };
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;update()})};
  stickyAdd.addEventListener('click',()=>{if(!mainAdd.disabled){mainAdd.click();schedule()}});
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  if(currentPrice){new MutationObserver(schedule).observe(currentPrice,{subtree:true,characterData:true,childList:true})}
  const options=form.querySelectorAll('[data-option-value],[data-qty],[data-product-variant-select]');
  options.forEach(el=>{el.addEventListener('click',schedule);el.addEventListener('change',schedule)});
  update();
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();